import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import LazyLoadingImg from "./LazyLoadingImg";
import { Autoplay } from "swiper/modules";
import useWindowWidth from "../../hooks/useWindowWidth";

export default function IndustriesPortfolio() {
  const [activeIndex, setActiveIndex] = useState(0);
  const width = useWindowWidth();
  return (
    <div className="my-lg-5 my-0">
      <div className="container-fluid px-0 pb-lg-5">
        <div className="col-12 text-center py-lg-4">
          <h2 className="clr0E2B3D headerFontSizeH6">
            Industries that we serve
          </h2>
          <h3 className="clr0E2B3D headerFontSizeH3New h1Tag">
            We serve clients diversified in almost all the industries.
          </h3>
          <img src="images/hrImg.png" alt="" className="img-fluid" />
        </div>

        <div className="row IS_Containers">
          <Swiper
            slidesPerView={width < 768 ? 3 : 5}
            spaceBetween={20}
            centeredSlides={true}
            loop={true}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
            speed={1500}
            modules={[Autoplay]}
            onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
            className="IndustriesPortfolioSwiper w-100"
          >
            {[
              {
                bg: "/images/portfolio-industries-images/Banking.svg",
                // inside: "/images/portfolio-industries-inside.svg",
                text: "Banking",
              },
              {
                bg: "/images/portfolio-industries-images/Coworking.svg",
                // inside: "/images/portfolio-industries-inside.svg",
                text: "Coworking",
              },
              {
                bg: "/images/portfolio-industries-images/Ecommerce.svg",
                // inside: "/images/portfolio-industries-inside.svg",
                text: "Ecommerce",
              },
              {
                bg: "/images/portfolio-industries-images/Education.svg",
                // inside: "/images/portfolio-industries-inside.svg",
                text: "Education",
              },
              {
                bg: "/images/portfolio-industries-images/Food Delivery.svg",
                // inside: "/images/portfolio-industries-inside.svg",
                text: "Food Delivery",
              },
              {
                bg: "/images/portfolio-industries-images/IT Solutins.svg",
                // inside: "/images/portfolio-industries-inside.svg",
                text: "IT Solutins",
              },
              {
                bg: "/images/portfolio-industries-images/Lifestyle.svg",
                // inside: "/images/portfolio-industries-inside.svg",
                text: "Lifestyle",
              },
              {
                bg: "/images/portfolio-industries-images/Real estate.svg",
                // inside: "/images/portfolio-industries-inside.svg",
                text: "Real estate",
              },
              {
                bg: "/images/portfolio-industries-images/Sports.svg",
                // inside: "/images/portfolio-industries-inside.svg",
                text: "Sports",
              },
              {
                bg: "/images/portfolio-industries-images/Telecommunication.svg",
                // inside: "/images/portfolio-industries-inside.svg",
                text: "Telecommunication",
              },
              {
                bg: "/images/portfolio-industries-images/Travel.svg",
                // inside: "/images/portfolio-industries-inside.svg",
                text: "Travel",
              },
            ].map((imgObj, idx) => (
              <SwiperSlide key={idx}>
                <div
                  className={
                    activeIndex === idx ? "slide-img active-slide" : "slide-img"
                  }
                >
                  <div className="center-img position-relative">
                    <LazyLoadingImg
                      src={imgObj.bg}
                      alt="Portfolio Background"
                      title="Portfolio Background"
                      className="maxwid-80 portfolio-img"
                    />
                    {/* <img
                      src={imgObj.inside}
                      alt="Portfolio Inside"
                      title="Portfolio Inside"
                      className="inside-img"
                    /> */}
                    <div className="portfolio-slide-text">{imgObj.text}</div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
}
